import { render, staticRenderFns } from "./PlateHealthDetails.vue?vue&type=template&id=6d4a9dea&scoped=true&"
import script from "./PlateHealthDetails.vue?vue&type=script&lang=js&"
export * from "./PlateHealthDetails.vue?vue&type=script&lang=js&"
import style0 from "./PlateHealthDetails.vue?vue&type=style&index=0&id=6d4a9dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a9dea",
  null
  
)

export default component.exports